import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"

function CaseEscalated({ClientName}: {ClientName: string}) {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.case_escalated.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" className="amp-mask">
					<Trans i18nKey="customer_get.case_escalated.message" values={{ClientName: ClientName}} />
				</Typography>
			</Grid>
		</Page>
	)
}

export {CaseEscalated}
